export const loaderStore = {
  activeRequests: 0,
  isOpen: false
};

export interface ILoaderStore {
  activeRequests: number;
  isOpen: boolean;
}
